/***
 *
 *   STACKGO SURVEYJS THEME
 *   Per-model theme applied to STAFF-facing SurveyJS surfaces only.
 *   Client-facing/public views keep the stock SurveyJS defaultV2 theme
 *   (frozen under .theme-identitycheck) — never apply this there.
 *
 **********/

import "./stackgo-surveyjs.css";

export const stackgoTheme = {
  themeName: "stackgo",
  colorPalette: "light",
  isPanelless: false,
  cssVariables: {
    "--sjs-primary-backcolor": "#0038cf",
    "--sjs-primary-backcolor-dark": "#002ba3",
    "--sjs-primary-backcolor-light": "rgba(0,56,207,0.10)",
    "--sjs-primary-forecolor": "#ffffff",
    "--sjs-primary-forecolor-light": "rgba(255,255,255,0.9)",
    "--sjs-general-backcolor": "#ffffff",
    "--sjs-general-backcolor-dim": "#f4f6fc",
    "--sjs-general-backcolor-dim-light": "#ffffff",
    "--sjs-general-forecolor": "#000000",
    "--sjs-general-forecolor-light": "#5a6072",
    "--sjs-general-dim-forecolor": "#4a5568",
    "--sjs-special-red": "#8b1a15",
    "--sjs-special-red-light": "#fdecea",
    "--sjs-border-default": "#E4E7EE",
    "--sjs-border-light": "#F1F3F8",
    "--sjs-corner-radius": "12px",
    "--sjs-base-unit": "6px",
    "--sjs-font-size": "15px",
    "--sjs-font-family": "Roboto, system-ui, sans-serif",
    "--sjs-font-surveytitle-family": "Mont, sans-serif",
    "--sjs-font-surveytitle-weight": "700",
    "--sjs-font-surveytitle-size": "22px",
    "--sjs-font-pagetitle-family": "Mont, sans-serif",
    "--sjs-font-pagetitle-size": "17px",
    "--sjs-font-questiontitle-family": "Roboto, sans-serif",
    "--sjs-font-questiontitle-size": "14px",
    "--sjs-font-editorfont-family": "Roboto, sans-serif",
    "--sjs-font-editorfont-size": "14px",
    "--sjs-shadow-small": "0 1px 2px rgba(20,30,60,0.06)",
    "--sjs-shadow-inner": "inset 0 1px 2px rgba(20,30,60,0.06)",
  },
};

export function applyStackgoTheme(model) {
  if (model && typeof model.applyTheme === "function")
    model.applyTheme(stackgoTheme);
  return model;
}
